import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

/**
 * Filter bar under a page header. Default content (search, boxed selects) sits
 * on the left; a `.filter-end` element (view toggle, Clear filters) on the
 * right; an optional `.filter-chips` element takes its own row below.
 */
@Component({
  selector: 'app-content-filter-cabinet',
  templateUrl: './content-filter.component.html',
  styleUrl: './content-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ContentFilterCabinetComponent {}
